import { Outlet } from 'react-router-dom';

export const Investor = () => {
	return <Outlet></Outlet>;
};
